import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CompletenesWrapperProps as Props } from './types';
import { CompletenesItem } from '../completenes-item';

export const CompletenesWrapper = memo(
  ({ className, items, isPeople }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('CompletenesWrapper', className)}
        sx={SX.root}
      >
        {items.map((i, index) => (
          <CompletenesItem
            key={i.name}
            item={i}
            isPeople={isPeople}
            isLast={index === items.length - 1}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

CompletenesWrapper.displayName = 'CompletenesWrapper';
